<template>
  <div>
    <div style="margin-top: 15%;">
      <el-row type="flex" class="row-bg" justify="center">
        <el-col :xl="6" :lg="7">
          <h1>欢迎来到心梨后台管理系统</h1>
          <el-image :src="require('@/assets/xinliLogo.png')" style="height: 160px; width: 355px;"></el-image>
        </el-col>

        <el-col :span="1">
          <el-divider direction="vertical"></el-divider>
        </el-col>
        <el-col :xl="6" :lg="7">
          <el-form :model="loginForm" :rules="rules" ref="loginForm" label-width="80px" style="margin-top: 50px">
            <el-form-item label="用户名" prop="username" style="width: 380px;">
              <el-input v-model="loginForm.username"></el-input>
            </el-form-item>
            <el-form-item label="密码" prop="password"  style="width: 380px;">
              <el-input v-model="loginForm.password" type="password"></el-input>
            </el-form-item>
            <el-form-item label="验证码" prop="code"  style="width: 380px;">
              <el-input v-model="loginForm.code"  style="width: 152px; float: left" maxlength="5" @keyup.enter.native="submitForm('loginForm')"></el-input>
              <el-image v-if="captchaImgWithTs" :src="captchaImgWithTs" :key="loginForm.captchaKey" class="captchaImg" style="width: 120px; height: 40px;" fit="contain" @click="getCaptcha" @error="onCaptchaError"></el-image>
              <span v-else class="captchaImg" style="width: 120px; height: 40px; line-height: 40px; background: #f5f7fa; color: #909399; display: inline-block; text-align: center;">加载中...</span>
            </el-form-item>

            <el-form-item >
              <div style="display: flex">
                <el-button type="primary" @click="submitForm('loginForm')">登录</el-button>
                <el-button  style="margin-left: 40px" @click="resetForm('loginForm')">重置</el-button>
              </div>

            </el-form-item>
          </el-form>
        </el-col>
      </el-row>
    </div>
    <div style="margin-top: 50px; text-align: center">
      <el-link href="https://beian.miit.gov.cn" target="_blank">工业和信息化部备案管理系统网站 沪ICP备16034788号-4</el-link>
      <div style="color: #686767;">上海心梨信息科技有限公司</div>
    </div>
  </div>
</template>

<script>

	import qs from 'qs'

	export default {
		name: "Login",

		data() {
			return {
				loginForm: {
					username: '',
					password: '',
					code: '',
          captchaKey: ''
				},
				rules: {
					username: [
						{ required: true, message: '请输入用户名', trigger: 'blur' }
					],
					password: [
						{ required: true, message: '请输入密码', trigger: 'blur' }
					],
					code: [
						{ required: true, message: '请输入验证码', trigger: 'blur' },
						{ min: 5, max: 5, message: '长度为5个字符', trigger: 'blur' }
					],
				},
				captchaImg: null
			};
		},

    created() {
      this.getCaptcha()
    },

		methods: {
			submitForm(formName) {
				this.$refs[formName].validate((valid) => {
					if (valid) {
						this.$axios.post('/api/login?'+ qs.stringify(this.loginForm)).then(res => {
              if (res.data.code !== 200) {
                this.loginForm.code = ''
                this.getCaptcha()
              } else {
                // 兼容多种后端返回token位置：响应头或响应体
                let jwt = null
                // axios 将 header 字段名转为小写
                const h = res && res.headers ? res.headers : {}
                if (h['token']) {
                  jwt = h['token']
                } else if (h['authorization']) {
                  // 可能是 "Bearer xxx"
                  const auth = h['authorization']
                  jwt = auth && auth.toLowerCase().startsWith('bearer ')
                    ? auth.slice(7).trim()
                    : auth
                }
                if (!jwt) {
                  const d = res && res.data && res.data.data ? res.data.data : {}
                  jwt = d.token || d.access_token || d.jwt || ''
                }
                if (!jwt) {
                  this.$message.error('登录成功但未获取到令牌，请联系后端或检查返回格式')
                }
                this.$store.commit('setToken', jwt || '')
                this.$store.commit('setUserId', res.data.data.userId)
                this.$store.commit('setUsername', res.data.data.username)
                this.$router.push("/index")
              }
				}).catch(err => {
                  // 登录请求异常统一提示，并刷新验证码
                  this.$message.error(err && err.message ? err.message : '登录失败，请重试')
                  this.loginForm.code = ''
                  this.getCaptcha()
                })
              } else {
                console.log('error submit!!');
                return false;
              }
			});
			},

			resetForm(formName) {
				this.$refs[formName].resetFields();
			},

			getCaptcha() {
				this.$axios.get('/api/captcha').then(res => {
					this.loginForm.captchaKey = res.data.data.captchaKey
					this.captchaImg = res.data.data.captchaImg
					this.loginForm.code = ''
				}).catch(err => {
                // 获取验证码异常统一提示
                this.$message.error(err && err.message ? err.message : '获取验证码失败，请重试')
              })
			},
      onCaptchaError() {
        // 发生错误时重试获取一次
        this.getCaptcha()
      }
		},

    computed: {
      captchaImgWithTs() {
        if (!this.captchaImg) return null
        const ts = Date.now()
        if (this.captchaImg.startsWith('data:image')) {
          return this.captchaImg
        }
        const sep = this.captchaImg.includes('?') ? '&' : '?'
        return `${this.captchaImg}${sep}_=${ts}`
      }
    }
	}
</script>

<style scoped>

	.el-row {
		background-color: #fafafa;
		height: 100%;
		display: flex;
		align-items: center;
		text-align: center;
		justify-content: center;
	}

	.el-divider {
    margin-top: 40px;
		height: 240px;
	}

	.captchaImg {
		float: left;
		margin-left: 8px;
		border-radius: 4px;
	}

</style>



// WEBPACK FOOTER //
// src/views/Login.vue